import PropTypes from "prop-types";
import "./ui.css";

// Card that groups a table with its toolbar and applied-filter chips.
export default function TableCard({ toolbar, chips, children }) {
  return (
    <section className="simcc-table-card">
      {toolbar}
      {chips}
      <div className="simcc-table-card__body">{children}</div>
    </section>
  );
}

TableCard.propTypes = {
  toolbar: PropTypes.node,
  chips: PropTypes.node,
  children: PropTypes.node,
};

TableCard.defaultProps = {
  toolbar: undefined,
  chips: undefined,
  children: undefined,
};
